import {
  BillingCyclesUnit,
  BillingPeriodUnit,
  TrialPeriodUnit
} from '../../common/contracts';

export enum BillingCyclesEnum {
  FIXED = 'Fixed'
}

export enum BillingFrequencyEnum {
  DAILY = 'Daily',
  WEEKLY = 'Weekly',
  MONTHLY = 'Monthly',
  YEARLY = 'Yearly'
}

export enum TrialPeriodUnitEnum {
  DAYS = 'Days',
  MONTHS = 'Months'
}

export const TRIAL_PERIOD_UNIT_OPTIONS = [
  {
    label: TrialPeriodUnit.DAYS,
    value: TrialPeriodUnit.DAYS
  },
  {
    label: TrialPeriodUnit.MONTHS,
    value: TrialPeriodUnit.MONTHS
  }
];

export const BILLING_PERIOD_UNIT_OPTIONS = [
  {
    label: BillingFrequencyEnum.DAILY,
    value: BillingPeriodUnit.DAILY
  },
  {
    label: BillingFrequencyEnum.WEEKLY,
    value: BillingPeriodUnit.WEEKLY
  },
  {
    label: BillingFrequencyEnum.MONTHLY,
    value: BillingPeriodUnit.MONTHLY
  },
  {
    label: BillingFrequencyEnum.YEARLY,
    value: BillingPeriodUnit.YEARLY
  }
];

export const BILLING_CYCLES_UNIT_OPTIONS = [
  {
    label: BillingCyclesUnit.FIXED_NUMBER_OF_PAYMENTS,
    value: BillingCyclesUnit.FIXED_NUMBER_OF_PAYMENTS
  },
  {
    label: BillingCyclesUnit.ONGOING,
    value: BillingCyclesUnit.ONGOING
  }
];
